import type { OrderOperationalModel, OrderRooftopFacts } from '@hopdrive/feature-order-index';
import { DEFAULT_ORDER_OPERATIONAL_MODEL } from '@hopdrive/feature-order-index';

/** What the rooftop rows and the store's rooftop share, as far as the facts read. */
export interface RooftopFactsSource {
  id: number | string;
  name?: string | null;
  /** The generated types give jsonb as `object`; the facts carry it as a record. */
  effective_config?: object | null;
  location?: { id?: number | string | null; timezone?: string | null } | null;
}

/**
 * A rooftop row into the unified order display's rooftop facts, nulls where a value is missing.
 * The operational model defaults to the package default for the scope-list rooftops (which never
 * resolve orders directly); the Home feed sets the working rooftop's model from the accessor.
 */
export function toRooftopFacts(
  row: RooftopFactsSource,
  operationalModel: OrderOperationalModel = DEFAULT_ORDER_OPERATIONAL_MODEL,
): OrderRooftopFacts {
  return {
    id: Number(row.id),
    name: row.name ?? null,
    operationalModel,
    timezone: row.location?.timezone ?? null,
    locationId: row.location?.id === undefined || row.location?.id === null ? null : Number(row.location.id),
    effectiveConfig: (row.effective_config as Record<string, unknown> | null | undefined) ?? null,
  };
}
